import React, { useState, useEffect } from "react";
import "./index.css";
import "./SearchAskQuestionIndex.css";
import SuggestionAI from "./SuggestionAI";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import IMSIcon from "../iMSIcon/index";
import { Popover } from 'react-tiny-popover';
import { UserData } from '../../auth/Authorization'
import {
    imsLoader
} from "../../assets";
import ApiServices from "../../utils/apiServices";
import { isShowAIMode, isShowAIOverview } from "../../utils/utilityServices"
import ResponsiveFilterComponent from "../../content/ResponsiveFilterComponent/ResponsiveFilterComponent"

export default function SearchAskQuestionIndex(props) {
    const [customWidth, setCustomWidth] = useState(props.customWidth);
    const [customHeight, setCustomHeight] = useState(props.customHeight);
    const [searchKeyword, setSearchKeyword] = useState(props.searchKeyword);
    const [showContentShortcuts, setShowContentShortcuts] = useState(props.showContentShortcuts);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [keyEventName, setKeyEventName] = useState('');
    const [keyBoardEvent, setKeyBoardEvent] = useState(false);
    const [showFilters, setShowFilters] = useState(props.showFilters);
    const [showOptions, setShowOptions] = useState("");
    const [dropdownValue, setDropdownValue] = useState(props.dropdownValue);
    const [fieldedValue, setFieldedValue] = useState(props.fieldedValue);
    const [isDisableAIOverview, setIsDisableAIOverview] = useState(false);
    const [isDisableAIOverviewProcessing, setIsDisableAIOverviewProcessing] = useState(true);
    const [bannerMessage, setBannerMessage] = useState("");
    const history = useHistory();

    useEffect(() => {
        setShowFilters(props.showFilters)
    }, [props.showFilters]);
    useEffect(() => {
        setShowContentShortcuts(props.showContentShortcuts)
    }, [props.showContentShortcuts]);

    useEffect(() => {
        setDropdownValue(props.dropdownValue)
    }, [props.dropdownValue]);

    useEffect(() => {
        setFieldedValue(props.fieldedValue)
    }, [props.fieldedValue]);
    useEffect(() => {
        setCustomWidth(props.customWidth);
        setCustomHeight(props.customHeight);
    }, [props.customWidth, props.customHeight]);
    useEffect(async () => {
        await getUserIsDisableAIOverview();
        await getBannerMessage();
    }, []);
    const getUserIsDisableAIOverview = async () => {
        const services = new ApiServices();
        let wwid = UserData.sub;
        var response = await services.getUserIsDisableAIOverview(wwid);
        if (response) {
            setIsDisableAIOverview(response.is_disable_aioverview)
        }
        setIsDisableAIOverviewProcessing(false);
    }
    const handleChangeInSearch = (event) => {
        setSearchKeyword(event.target.value);
        setShowSuggestions(true)
    }
    const getBannerMessage = async () => {
        let apiService = new ApiServices();
        let banner = await apiService.getBannerMessage();
        if (banner && banner.length > 0) {
            let firstBannerMessage = banner[0];
            if (firstBannerMessage.is_visible) {
                setBannerMessage(firstBannerMessage.message)
            }
        }
    };

    const handleKeyDown = async (event) => {
        if (['Enter'].includes(event.key) && !event.shiftKey && searchKeyword && searchKeyword.trim()) {
            event.preventDefault();
            event.returnValue = false;
            await handleOnClickSearchIcon();
        }
        if (["ArrowDown"].includes(event.key) || ["ArrowUp"].includes(event.key)) {
            //console.log('Arrow Action')
            setKeyBoardEvent(true)
            setKeyEventName(event.key)
        }
    }

    const handleOnClickSearchIcon = () => {
        props.handleChangeInSearch(searchKeyword, dropdownValue, fieldedValue);
        setKeyBoardEvent(false)
        setKeyEventName('')
    }
    const handleOnClickIsDisableAIOverview = async () => {
        setIsDisableAIOverviewProcessing(true);
        const services = new ApiServices();
        let wwid = UserData.sub;
        var response = await services.updateIsDisableAIOverview(wwid, !isDisableAIOverview);
        await getUserIsDisableAIOverview();
    }

    const handleOnChange = (query, fieldParam) => {
        setSearchKeyword(query);
        setShowSuggestions(false);
        //handleOnClickSearchIcon();
    };
    const handlePubMedSearch = () => {
        let url = `/PubMedSearch?query=${encodeURIComponent(searchKeyword)}&filters=&q=`;
        history.push(url)
    }
    const onClickCancel = () => {
        setSearchKeyword("")
        setShowSuggestions(false);
    }
    const handleAIMode = () => {
        props.handleAIMode(searchKeyword);
        setKeyBoardEvent(false)
        setKeyEventName('')
    }
    const handleChangeInDropdown = (event) => {
        //console.log(event.target.attributes.keyValue.value);
        let fieldedVal;
        event.preventDefault();
        if (event.target.attributes.keyvalue.value === "All Fields") {
            fieldedVal = "";
        } else if (event.target.attributes.keyvalue.value === "Author") {
            fieldedVal = "authors";
        } else if (event.target.attributes.keyvalue.value === "Congress") {
            fieldedVal = "fullCnSf";
        } else if (event.target.attributes.keyvalue.value === "Document Type") {
            fieldedVal = "docTypeSynonyms";
        } else if (event.target.attributes.keyvalue.value === "Title") {
            fieldedVal = "docTitle";
        } else if (event.target.attributes.keyvalue.value === "Publication Year") {
            fieldedVal = "strYear";
        } else if (event.target.attributes.keyvalue.value === "Journal Name") {
            fieldedVal = "journalName";
        } else if (event.target.attributes.keyvalue.value === "Document Number") {
            fieldedVal = "documentNumber";
        }
        setDropdownValue(event.target.attributes.keyvalue.value);
        setShowOptions(!showOptions);
        setFieldedValue(fieldedVal)
    };
    if (customWidth <= 1000) {
        return (
            <div className="genAIRecommended-main-ask-question-wrapper">
                <IMSIcon />
                {bannerMessage && <div className="genAIRecommended-main-banner-message">{bannerMessage}</div>}
                <div className="genAIRecommended-main-search-input-wrapper" style={{ position: 'relative', height: '50px' }}>
                    <div className="genAIRecommended-main-search-input-ai-button-wrapper" style={{ position: 'absolute', top: '0', zIndex: '1' }}>
                        <div className="genAIRecommended-main-input-box-wrapper"
                            onMouseLeave={() => { setShowSuggestions(false) }}>
                            <div className="genAIRecommended-main-input-box-container">
                                {/* <span className="genAIRecommended-main-icon-wrapper">
                                <span className="genAIRecommended-main-search-icon-wrapper-webView">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17.5 17.5L13.8833 13.8834" stroke="#99A1AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#99A1AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </span> */}
                                <input name="searchBar" placeholder="Search..." className="genAIRecommended-main-input-search-box" title="What are you looking for?" value={searchKeyword} onChange={handleChangeInSearch} onKeyDown={handleKeyDown} autoComplete="off" />
                                <button type="button" style={(searchKeyword && searchKeyword.length > 0) ? { visibility: "visible" } : { visibility: "hidden" }} className="genAIRecommended-cancel-button-ai-mode" onClick={onClickCancel}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16.5 5.5L5.5 16.5M5.5 5.5L16.5 16.5" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                                <button type="button" className="genAIRecommended-search-button-ai-mode" onClick={(e) => { handleOnClickSearchIcon() }}>
                                    {/* <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(90)">
                                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0.5C4.75329 0.5 0.5 4.75329 0.5 10C0.5 15.2467 4.75329 19.5 10 19.5C12.082 19.5 14.0076 18.8302 15.5731 17.6944L20.2929 22.4142C20.6834 22.8047 21.3166 22.8047 21.7071 22.4142L22.4142 21.7071C22.8047 21.3166 22.8047 20.6834 22.4142 20.2929L17.6944 15.5731C18.8302 14.0076 19.5 12.082 19.5 10C19.5 4.75329 15.2467 0.5 10 0.5ZM3.5 10C3.5 6.41015 6.41015 3.5 10 3.5C13.5899 3.5 16.5 6.41015 16.5 10C16.5 13.5899 13.5899 16.5 10 16.5C6.41015 16.5 3.5 13.5899 3.5 10Z" fill="#eb1600"></path> </g>
                                    </svg> */}
                                    {/* <svg  width="22" height="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                                        <path d="M20.08 3.17c-1.61 0-3.18.44-4.55 1.28a8.8 8.8 0 0 0-3.22 3.46 8.75 8.75 0 0 0-.94 4.63c.12 1.6.68 3.14 1.61 4.44.28.41.28.76-.09 1.03-1.89 1.35-3.28.12-5.31 2.15l-4.4 4.42 4.24 4.24 4.44-4.45c2.04-2.04.76-3.39 2.1-5.29.28-.36.62-.38 1.03-.09 1.12.8 2.41 1.32 3.77 1.53s2.75.09 4.05-.34a8.8 8.8 0 0 0 3.46-2.14c.97-.98 1.69-2.17 2.11-3.48s.53-2.7.31-4.06a8.8 8.8 0 0 0-1.56-3.76 8.7 8.7 0 0 0-3.1-2.64 8.8 8.8 0 0 0-3.96-.95zm0 15.49a6.76 6.76 0 0 1-6.25-4.17 6.68 6.68 0 0 1-.38-3.9c.26-1.31.9-2.51 1.85-3.46.95-.94 2.15-1.59 3.46-1.85a6.7 6.7 0 0 1 3.91.39 6.76 6.76 0 0 1 4.17 6.24c0 1.79-.71 3.51-1.98 4.77a6.8 6.8 0 0 1-4.78 1.98" style="fill:#eb1600" />
                                    </svg> */}
                                    {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                        <path d="M19.25 19.25L13.7501 13.75M15.5833 9.16667C15.5833 12.7105 12.7105 15.5833 9.16667 15.5833C5.62284 15.5833 2.75 12.7105 2.75 9.16667C2.75 5.62284 5.62284 2.75 9.16667 2.75C12.7105 2.75 15.5833 5.62284 15.5833 9.16667Z" stroke="#eb1600" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg> */}
                                    <svg fill="#ffffff" width="36" height="36" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="-117.76 -117.76 747.52 747.52" enable-background="new 0 0 512 512" transform="matrix(1, 0, 0, 1, 0, 0)" stroke="#ffffff" stroke-width="0.00512">
                                        <g id="SVGRepo_bgCarrier" stroke-width="0">
                                            <rect x="-117.76" y="-117.76" width="747.52" height="747.52" rx="373.76" fill="#EB1700" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path d="M325.8,0C223,0,139.6,83.4,139.6,186.2c0,33.5,9,64.8,24.4,92L0,442.2l23.3,46.5L69.8,512l164-164 c27.1,15.5,58.5,24.4,92,24.4C428.6,372.4,512,289,512,186.2S428.6,0,325.8,0z M325.8,314.2c-70.7,0-128-57.3-128-128 c0-70.7,57.3-128,128-128s128,57.3,128,128C453.8,256.9,396.5,314.2,325.8,314.2z"></path>
                                        </g>
                                    </svg>
                                </button>


                            </div>

                            {(searchKeyword && searchKeyword.length > 2) && <> <SuggestionAI
                                isFromResultPage={false}
                                searchKeyword={searchKeyword}
                                showSuggestions={showSuggestions}
                                handleOnChange={handleOnChange}
                                keyBoardEvent={keyBoardEvent}
                                keyEventName={keyEventName}
                                setKeyBoardEvent={() => { setKeyBoardEvent(false) }}
                            />
                                {/* <div className="genAIRecommended-main-input-box-container-footer">
                                <button className="genAIRecommended-footer-button" style={{ marginRight: '20px' }} onClick={() => handleOnClickSearchIcon(false)}>iMS Search</button>
                                <button className="genAIRecommended-footer-button" onClick={handlePubMedSearch}>Literature Search</button>
                            </div>
                            */}
                            </>}
                        </div>
                        {isShowAIMode() && <button type="button" className="genAIRecommended-main-button-ai-mode" onClick={(e) => { handleAIMode() }} >
                            <div className="segment-control">
                                <div className="segment-content">
                                    <div className="segment-icon">
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.62479 10.3334C6.56527 10.1026 6.44502 9.89209 6.27653 9.72361C6.10805 9.55513 5.8975 9.43488 5.66679 9.37536L1.57679 8.32069C1.50701 8.30088 1.4456 8.25886 1.40186 8.20099C1.35813 8.14312 1.33447 8.07256 1.33447 8.00002C1.33447 7.92749 1.35813 7.85693 1.40186 7.79906C1.4456 7.74119 1.50701 7.69916 1.57679 7.67936L5.66679 6.62402C5.89742 6.56456 6.10792 6.44441 6.27639 6.27605C6.44486 6.10769 6.56517 5.89728 6.62479 5.66669L7.67946 1.57669C7.69906 1.50664 7.74105 1.44492 7.799 1.40095C7.85696 1.35699 7.92771 1.33319 8.00046 1.33319C8.0732 1.33319 8.14395 1.35699 8.20191 1.40095C8.25987 1.44492 8.30185 1.50664 8.32146 1.57669L9.37546 5.66669C9.43497 5.8974 9.55523 6.10795 9.72371 6.27644C9.89219 6.44492 10.1027 6.56517 10.3335 6.62469L14.4235 7.67869C14.4938 7.69809 14.5558 7.74003 14.6 7.79807C14.6442 7.85612 14.6682 7.92706 14.6682 8.00002C14.6682 8.07298 14.6442 8.14393 14.6 8.20197C14.5558 8.26002 14.4938 8.30196 14.4235 8.32136L10.3335 9.37536C10.1027 9.43488 9.89219 9.55513 9.72371 9.72361C9.55523 9.89209 9.43497 10.1026 9.37546 10.3334L8.32079 14.4234C8.30118 14.4934 8.2592 14.5551 8.20124 14.5991C8.14328 14.6431 8.07254 14.6669 7.99979 14.6669C7.92704 14.6669 7.85629 14.6431 7.79834 14.5991C7.74038 14.5551 7.69839 14.4934 7.67879 14.4234L6.62479 10.3334Z" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M13.3335 2V4.66667" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M14.6667 3.33331H12" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M2.6665 11.3333V12.6666" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M3.33333 12H2" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </div>
                                    <div className="segment-label">AI Mode</div>
                                </div>
                            </div>
                        </button>}
                    </div>
                </div>
                <div className="genAIRecommended-main-icons-titles-wrapper">
                    <div className="genAIRecommended-main-icons-titles">
                        <div className="genAIRecommended-main-icons-filter-cs-wrapper">
                            <ResponsiveFilterComponent 
                            pathName={window.location.pathname} allFilters={props.allFilters}
                                filters={props.filters}
                                appliedFilters={props.appliedFilters}
                                handleAllfilters={props.handleAllFilters}
                                handleOnChangeInfilter={props.handleOnChangeInfilter}
                                selectedFilters={props.selectedFilters}
                                selectedParentFilterArr={props.selectedParentFilterArr}
                                querytext={props.searchKeyword}
                                isProcessing={props.isProcessing}
                                handleIsProcessing={props.handleIsProcessing}
                                customWidth={props.customWidth}
                                recentlyUsedFilters={props.recentlyUsedFilters}
                                fromRecentlyAddedUpdated={props.fromRecentlyAddedUpdated}
                                toRecentlyAddedUpdated={props.toRecentlyAddedUpdated}
                                gotoPageRecentlyAddedUpdated={props.gotoPageRecentlyAddedUpdated}
                                isHomePageFilter={true} />
                            {/* <button type="button" className={showFilters ? "popoverAvoidClickOutside genAIRecommended-main-icon-title genAIRecommended-main-icon-title-active" : "popoverAvoidClickOutside genAIRecommended-main-icon-title"} onClick={e => { setShowOptions(false); props.handleShowFilters(!showFilters) }}>
                                <svg className="popoverAvoidClickOutside" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path className="popoverAvoidClickOutside" d="M3.99993 8H11.9996M2 4H13.9996M5.99986 12H9.99972" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <div className="genAIRecommended-main-title popoverAvoidClickOutside">Filter</div>
                            </button> */}
                            {JSON.parse(localStorage.getItem('function')) !== "Commercial" &&
                                <button type="button" className={showContentShortcuts ? "genAIRecommended-main-icon-title genAIRecommended-main-icon-title-active" : "genAIRecommended-main-icon-title"} onClick={e => { setShowOptions(false); props.handleShowContentShortcuts(!showContentShortcuts) }}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.9996 6.00001L13.9996 2.00001M13.9996 2.00001H9.99971M13.9996 2.00001L7.99979 8M6.6665 2H5.19989C4.07982 2 3.51979 2 3.09198 2.21799C2.71567 2.40973 2.40972 2.71569 2.21798 3.09202C2 3.51984 2 4.07989 2 5.2V10.8C2 11.9201 2 12.4802 2.21798 12.908C2.40972 13.2843 2.71567 13.5903 3.09198 13.782C3.51979 14 4.07982 14 5.19989 14H10.7997C11.9198 14 12.4798 14 12.9076 13.782C13.2839 13.5903 13.5899 13.2843 13.7816 12.908C13.9996 12.4802 13.9996 11.9201 13.9996 10.8V9.33333" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <div className="genAIRecommended-main-title popoverAvoidClickOutside-cs">Content Shortcuts</div>
                                </button>}
                            {/* <div className="search-input-wrapper"> */}
                            <div
                                className="genAIRecommended-main-dropdown genAIRecommended-main-searchSelect"
                            // onMouseLeave={this.handleCategoryClose}
                            ><Popover
                                isOpen={showOptions}
                                positions={['bottom', 'right']}
                                align={'center'}
                                containerClassName="react-tiny-popover-container"
                                // scrollable
                                containerStyle={{
                                    top: '10px',
                                }}
                                onClickOutside={(e) => {
                                    if (!(e && e.srcElement && e.srcElement.classList && (e.srcElement.classList.contains('popoverAvoidClickOutside') || e.srcElement.classList.contains('popoverAvoidClickOutside-af') || e.srcElement.closest(".react-tiny-popover-container")))) {
                                        setShowOptions(false);
                                    }
                                }}
                                content={(positions, align) => (
                                    <ul className="allFieldsListing genAIRecommended-main-searchSelect-allFieldsListing">
                                        {dropdownValue === "All Fields" ? null : (
                                            <li
                                                keyvalue="All Fields"
                                                onClick={handleChangeInDropdown}
                                            >
                                                All Fields
                                            </li>
                                        )}
                                        {dropdownValue === "Author" ? null : (
                                            <li
                                                keyvalue="Author"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Author
                                            </li>
                                        )}
                                        {dropdownValue === "Congress" ? null : (
                                            <li
                                                keyvalue="Congress"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Congress
                                            </li>
                                        )}
                                        {dropdownValue === "Document Type" ? null : (
                                            <li
                                                keyvalue="Document Type"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Document Type
                                            </li>
                                        )}
                                        {dropdownValue === "Title" ? null : (
                                            <li
                                                keyvalue="Title"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Title
                                            </li>
                                        )}
                                        {dropdownValue === "Publication Year" ? null : (
                                            <li
                                                keyvalue="Publication Year"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Publication Year
                                            </li>
                                        )}
                                        {dropdownValue === "Journal Name" ? null : (
                                            <li
                                                keyvalue="Journal Name"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Journal Name
                                            </li>
                                        )}
                                        {dropdownValue === "Document Number" ? null : (
                                            <li
                                                keyvalue="Document Number"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Document Number
                                            </li>
                                        )}
                                    </ul>
                                )}>
                                    <button type="button" className={showOptions ? "genAIRecommended-main-icon-title genAIRecommended-main-icon-title-active" : "genAIRecommended-main-icon-title"} onClick={e => { setShowOptions(!showOptions); }}>
                                        <svg style={showOptions ? {} : { transform: "matrix(-1, 0, 0, -1, 0, 0)" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="Triangle" width="17" height="17">
                                            <path d="M4 24h24L16 6z" fill="#212121" class="color000000 svgShape"> </path>
                                        </svg>
                                        <div className="genAIRecommended-main-title popoverAvoidClickOutside-af genAIRecommended-main-icon-title-all-fields">{dropdownValue}</div>
                                    </button>
                                </Popover>
                                {/* {showOptions ? (
                                    <ul className="allFieldsListing">
                                        {dropdownValue === "All Fields" ? null : (
                                            <li
                                                keyvalue="All Fields"
                                                onClick={handleChangeInDropdown}
                                            >
                                                All Fields
                                            </li>
                                        )}
                                        {dropdownValue === "Author" ? null : (
                                            <li
                                                keyvalue="Author"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Author
                                            </li>
                                        )}
                                        {dropdownValue === "Congress" ? null : (
                                            <li
                                                keyvalue="Congress"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Congress
                                            </li>
                                        )}
                                        {dropdownValue === "Document Type" ? null : (
                                            <li
                                                keyvalue="Document Type"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Document Type
                                            </li>
                                        )}
                                        {dropdownValue === "Title" ? null : (
                                            <li
                                                keyvalue="Title"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Title
                                            </li>
                                        )}
                                        {dropdownValue === "Publication Year" ? null : (
                                            <li
                                                keyvalue="Publication Year"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Publication Year
                                            </li>
                                        )}
                                        {dropdownValue === "Journal Name" ? null : (
                                            <li
                                                keyvalue="Journal Name"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Journal Name
                                            </li>
                                        )}
                                        {dropdownValue === "Document Number" ? null : (
                                            <li
                                                keyvalue="Document Number"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Document Number
                                            </li>
                                        )}
                                    </ul>
                                ) : null} */}
                            </div>
                            {/* </div> */}
                        </div>
                        <div className="genAIRecommended-main-disable-ai-overview-right">
                            {isShowAIOverview() && <div className="genAIRecommended-main-disable-ai-overview-classSection">
                                {isDisableAIOverviewProcessing ? <img
                                    src={imsLoader}
                                    alt="Loading Data"
                                    style={{ height: "18px" }}
                                /> : <><input
                                    type="checkbox"
                                    id={`isDisableAIOverview`}
                                    value="isDisableAIOverview"
                                    name="classCheckBox"
                                    className="cname"
                                    onChange={handleOnClickIsDisableAIOverview}
                                    checked={isDisableAIOverview}
                                    class="k-checkbox"
                                    style={{ margin: "0px" }}
                                />
                                    <span onClick={handleOnClickIsDisableAIOverview} className="genAIRecommended-main-title">Document Search Only</span></>}

                            </div>}
                            <div style={{ visibility: "hidden", width: "125px" }} >&nbsp;</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    else if (customWidth > 1000) {
        return (
            <div className="genAIRecommended-main-ask-question-wrapper">
                <IMSIcon />
                {bannerMessage && <div className="genAIRecommended-main-banner-message">{bannerMessage}</div>}
                <div className="genAIRecommended-main-search-input-wrapper" style={{ position: 'relative', height: '50px' }}>
                    <div className="genAIRecommended-main-search-input-ai-button-wrapper" style={{ position: 'absolute', top: '0', zIndex: '1' }}>
                        <div className="genAIRecommended-main-input-box-wrapper"
                            onMouseLeave={() => { setShowSuggestions(false) }}>
                            <div className="genAIRecommended-main-input-box-container">
                                {/* <span className="genAIRecommended-main-icon-wrapper">
                                <span className="genAIRecommended-main-search-icon-wrapper-webView">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17.5 17.5L13.8833 13.8834" stroke="#99A1AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#99A1AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </span> */}
                                <input name="searchBar" placeholder="Search..." className="genAIRecommended-main-input-search-box" title="What are you looking for?" value={searchKeyword} onChange={handleChangeInSearch} onKeyDown={handleKeyDown} autoComplete="off" />
                                <button type="button" style={(searchKeyword && searchKeyword.length > 0) ? { visibility: "visible" } : { visibility: "hidden" }} className="genAIRecommended-cancel-button-ai-mode" onClick={onClickCancel}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16.5 5.5L5.5 16.5M5.5 5.5L16.5 16.5" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                                <button type="button" className="genAIRecommended-search-button-ai-mode" onClick={(e) => { handleOnClickSearchIcon() }}>
                                    {/* <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(90)">
                                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0.5C4.75329 0.5 0.5 4.75329 0.5 10C0.5 15.2467 4.75329 19.5 10 19.5C12.082 19.5 14.0076 18.8302 15.5731 17.6944L20.2929 22.4142C20.6834 22.8047 21.3166 22.8047 21.7071 22.4142L22.4142 21.7071C22.8047 21.3166 22.8047 20.6834 22.4142 20.2929L17.6944 15.5731C18.8302 14.0076 19.5 12.082 19.5 10C19.5 4.75329 15.2467 0.5 10 0.5ZM3.5 10C3.5 6.41015 6.41015 3.5 10 3.5C13.5899 3.5 16.5 6.41015 16.5 10C16.5 13.5899 13.5899 16.5 10 16.5C6.41015 16.5 3.5 13.5899 3.5 10Z" fill="#eb1600"></path> </g>
                                    </svg> */}
                                    {/* <svg  width="22" height="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                                        <path d="M20.08 3.17c-1.61 0-3.18.44-4.55 1.28a8.8 8.8 0 0 0-3.22 3.46 8.75 8.75 0 0 0-.94 4.63c.12 1.6.68 3.14 1.61 4.44.28.41.28.76-.09 1.03-1.89 1.35-3.28.12-5.31 2.15l-4.4 4.42 4.24 4.24 4.44-4.45c2.04-2.04.76-3.39 2.1-5.29.28-.36.62-.38 1.03-.09 1.12.8 2.41 1.32 3.77 1.53s2.75.09 4.05-.34a8.8 8.8 0 0 0 3.46-2.14c.97-.98 1.69-2.17 2.11-3.48s.53-2.7.31-4.06a8.8 8.8 0 0 0-1.56-3.76 8.7 8.7 0 0 0-3.1-2.64 8.8 8.8 0 0 0-3.96-.95zm0 15.49a6.76 6.76 0 0 1-6.25-4.17 6.68 6.68 0 0 1-.38-3.9c.26-1.31.9-2.51 1.85-3.46.95-.94 2.15-1.59 3.46-1.85a6.7 6.7 0 0 1 3.91.39 6.76 6.76 0 0 1 4.17 6.24c0 1.79-.71 3.51-1.98 4.77a6.8 6.8 0 0 1-4.78 1.98" style="fill:#eb1600" />
                                    </svg> */}
                                    {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                        <path d="M19.25 19.25L13.7501 13.75M15.5833 9.16667C15.5833 12.7105 12.7105 15.5833 9.16667 15.5833C5.62284 15.5833 2.75 12.7105 2.75 9.16667C2.75 5.62284 5.62284 2.75 9.16667 2.75C12.7105 2.75 15.5833 5.62284 15.5833 9.16667Z" stroke="#eb1600" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg> */}
                                    <svg fill="#ffffff" width="36" height="36" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="-117.76 -117.76 747.52 747.52" enable-background="new 0 0 512 512" transform="matrix(1, 0, 0, 1, 0, 0)" stroke="#ffffff" stroke-width="0.00512">
                                        <g id="SVGRepo_bgCarrier" stroke-width="0">
                                            <rect x="-117.76" y="-117.76" width="747.52" height="747.52" rx="373.76" fill="#EB1700" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path d="M325.8,0C223,0,139.6,83.4,139.6,186.2c0,33.5,9,64.8,24.4,92L0,442.2l23.3,46.5L69.8,512l164-164 c27.1,15.5,58.5,24.4,92,24.4C428.6,372.4,512,289,512,186.2S428.6,0,325.8,0z M325.8,314.2c-70.7,0-128-57.3-128-128 c0-70.7,57.3-128,128-128s128,57.3,128,128C453.8,256.9,396.5,314.2,325.8,314.2z"></path>
                                        </g>
                                    </svg>
                                </button>


                            </div>

                            {(searchKeyword && searchKeyword.length > 2) && <> <SuggestionAI
                                isFromResultPage={false}
                                searchKeyword={searchKeyword}
                                showSuggestions={showSuggestions}
                                handleOnChange={handleOnChange}
                                keyBoardEvent={keyBoardEvent}
                                keyEventName={keyEventName}
                                setKeyBoardEvent={() => { setKeyBoardEvent(false) }}
                            />
                                {/* <div className="genAIRecommended-main-input-box-container-footer">
                                <button className="genAIRecommended-footer-button" style={{ marginRight: '20px' }} onClick={() => handleOnClickSearchIcon(false)}>iMS Search</button>
                                <button className="genAIRecommended-footer-button" onClick={handlePubMedSearch}>Literature Search</button>
                            </div>
                            */}
                            </>}
                        </div>
                        {isShowAIMode() && <button type="button" className="genAIRecommended-main-button-ai-mode" onClick={(e) => { handleAIMode() }} >
                            <div className="segment-control">
                                <div className="segment-content">
                                    <div className="segment-icon">
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.62479 10.3334C6.56527 10.1026 6.44502 9.89209 6.27653 9.72361C6.10805 9.55513 5.8975 9.43488 5.66679 9.37536L1.57679 8.32069C1.50701 8.30088 1.4456 8.25886 1.40186 8.20099C1.35813 8.14312 1.33447 8.07256 1.33447 8.00002C1.33447 7.92749 1.35813 7.85693 1.40186 7.79906C1.4456 7.74119 1.50701 7.69916 1.57679 7.67936L5.66679 6.62402C5.89742 6.56456 6.10792 6.44441 6.27639 6.27605C6.44486 6.10769 6.56517 5.89728 6.62479 5.66669L7.67946 1.57669C7.69906 1.50664 7.74105 1.44492 7.799 1.40095C7.85696 1.35699 7.92771 1.33319 8.00046 1.33319C8.0732 1.33319 8.14395 1.35699 8.20191 1.40095C8.25987 1.44492 8.30185 1.50664 8.32146 1.57669L9.37546 5.66669C9.43497 5.8974 9.55523 6.10795 9.72371 6.27644C9.89219 6.44492 10.1027 6.56517 10.3335 6.62469L14.4235 7.67869C14.4938 7.69809 14.5558 7.74003 14.6 7.79807C14.6442 7.85612 14.6682 7.92706 14.6682 8.00002C14.6682 8.07298 14.6442 8.14393 14.6 8.20197C14.5558 8.26002 14.4938 8.30196 14.4235 8.32136L10.3335 9.37536C10.1027 9.43488 9.89219 9.55513 9.72371 9.72361C9.55523 9.89209 9.43497 10.1026 9.37546 10.3334L8.32079 14.4234C8.30118 14.4934 8.2592 14.5551 8.20124 14.5991C8.14328 14.6431 8.07254 14.6669 7.99979 14.6669C7.92704 14.6669 7.85629 14.6431 7.79834 14.5991C7.74038 14.5551 7.69839 14.4934 7.67879 14.4234L6.62479 10.3334Z" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M13.3335 2V4.66667" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M14.6667 3.33331H12" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M2.6665 11.3333V12.6666" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M3.33333 12H2" stroke="#000000" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </div>
                                    <div className="segment-label">AI Mode</div>
                                </div>
                            </div>
                        </button>}
                    </div>
                </div>
                <div className="genAIRecommended-main-icons-titles-wrapper">
                    <div className="genAIRecommended-main-icons-titles">
                        <div className="genAIRecommended-main-icons-filter-cs-wrapper">
                            <button type="button" className={showFilters ? "popoverAvoidClickOutside genAIRecommended-main-icon-title genAIRecommended-main-icon-title-active" : "popoverAvoidClickOutside genAIRecommended-main-icon-title"} onClick={e => { setShowOptions(false); props.handleShowFilters(!showFilters) }}>
                                <svg className="popoverAvoidClickOutside" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path className="popoverAvoidClickOutside" d="M3.99993 8H11.9996M2 4H13.9996M5.99986 12H9.99972" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <div className="genAIRecommended-main-title popoverAvoidClickOutside">Filter</div>
                            </button>
                            {JSON.parse(localStorage.getItem('function')) !== "Commercial" &&
                                <button type="button" className={showContentShortcuts ? "genAIRecommended-main-icon-title genAIRecommended-main-icon-title-active" : "genAIRecommended-main-icon-title"} onClick={e => { setShowOptions(false); props.handleShowContentShortcuts(!showContentShortcuts) }}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.9996 6.00001L13.9996 2.00001M13.9996 2.00001H9.99971M13.9996 2.00001L7.99979 8M6.6665 2H5.19989C4.07982 2 3.51979 2 3.09198 2.21799C2.71567 2.40973 2.40972 2.71569 2.21798 3.09202C2 3.51984 2 4.07989 2 5.2V10.8C2 11.9201 2 12.4802 2.21798 12.908C2.40972 13.2843 2.71567 13.5903 3.09198 13.782C3.51979 14 4.07982 14 5.19989 14H10.7997C11.9198 14 12.4798 14 12.9076 13.782C13.2839 13.5903 13.5899 13.2843 13.7816 12.908C13.9996 12.4802 13.9996 11.9201 13.9996 10.8V9.33333" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <div className="genAIRecommended-main-title popoverAvoidClickOutside-cs">Content Shortcuts</div>
                                </button>}
                            {/* <div className="search-input-wrapper"> */}
                            <div
                                className="genAIRecommended-main-dropdown genAIRecommended-main-searchSelect"
                            // onMouseLeave={this.handleCategoryClose}
                            ><Popover
                                isOpen={showOptions}
                                positions={['bottom', 'right']}
                                align={'center'}
                                containerClassName="react-tiny-popover-container"
                                // scrollable
                                containerStyle={{
                                    top: '10px',
                                }}
                                onClickOutside={(e) => {
                                    if (!(e && e.srcElement && e.srcElement.classList && (e.srcElement.classList.contains('popoverAvoidClickOutside') || e.srcElement.classList.contains('popoverAvoidClickOutside-af') || e.srcElement.closest(".react-tiny-popover-container")))) {
                                        setShowOptions(false);
                                    }
                                }}
                                content={(positions, align) => (
                                    <ul className="allFieldsListing genAIRecommended-main-searchSelect-allFieldsListing">
                                        {dropdownValue === "All Fields" ? null : (
                                            <li
                                                keyvalue="All Fields"
                                                onClick={handleChangeInDropdown}
                                            >
                                                All Fields
                                            </li>
                                        )}
                                        {dropdownValue === "Author" ? null : (
                                            <li
                                                keyvalue="Author"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Author
                                            </li>
                                        )}
                                        {dropdownValue === "Congress" ? null : (
                                            <li
                                                keyvalue="Congress"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Congress
                                            </li>
                                        )}
                                        {dropdownValue === "Document Type" ? null : (
                                            <li
                                                keyvalue="Document Type"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Document Type
                                            </li>
                                        )}
                                        {dropdownValue === "Title" ? null : (
                                            <li
                                                keyvalue="Title"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Title
                                            </li>
                                        )}
                                        {dropdownValue === "Publication Year" ? null : (
                                            <li
                                                keyvalue="Publication Year"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Publication Year
                                            </li>
                                        )}
                                        {dropdownValue === "Journal Name" ? null : (
                                            <li
                                                keyvalue="Journal Name"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Journal Name
                                            </li>
                                        )}
                                        {dropdownValue === "Document Number" ? null : (
                                            <li
                                                keyvalue="Document Number"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Document Number
                                            </li>
                                        )}
                                    </ul>
                                )}>
                                    <button type="button" className={showOptions ? "genAIRecommended-main-icon-title genAIRecommended-main-icon-title-active" : "genAIRecommended-main-icon-title"} onClick={e => { setShowOptions(!showOptions); }}>
                                        <svg style={showOptions ? {} : { transform: "matrix(-1, 0, 0, -1, 0, 0)" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="Triangle" width="17" height="17">
                                            <path d="M4 24h24L16 6z" fill="#212121" class="color000000 svgShape"> </path>
                                        </svg>
                                        <div className="genAIRecommended-main-title popoverAvoidClickOutside-af genAIRecommended-main-icon-title-all-fields">{dropdownValue}</div>
                                    </button>
                                </Popover>
                                {/* {showOptions ? (
                                    <ul className="allFieldsListing">
                                        {dropdownValue === "All Fields" ? null : (
                                            <li
                                                keyvalue="All Fields"
                                                onClick={handleChangeInDropdown}
                                            >
                                                All Fields
                                            </li>
                                        )}
                                        {dropdownValue === "Author" ? null : (
                                            <li
                                                keyvalue="Author"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Author
                                            </li>
                                        )}
                                        {dropdownValue === "Congress" ? null : (
                                            <li
                                                keyvalue="Congress"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Congress
                                            </li>
                                        )}
                                        {dropdownValue === "Document Type" ? null : (
                                            <li
                                                keyvalue="Document Type"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Document Type
                                            </li>
                                        )}
                                        {dropdownValue === "Title" ? null : (
                                            <li
                                                keyvalue="Title"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Title
                                            </li>
                                        )}
                                        {dropdownValue === "Publication Year" ? null : (
                                            <li
                                                keyvalue="Publication Year"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Publication Year
                                            </li>
                                        )}
                                        {dropdownValue === "Journal Name" ? null : (
                                            <li
                                                keyvalue="Journal Name"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Journal Name
                                            </li>
                                        )}
                                        {dropdownValue === "Document Number" ? null : (
                                            <li
                                                keyvalue="Document Number"
                                                onClick={handleChangeInDropdown}
                                            >
                                                Document Number
                                            </li>
                                        )}
                                    </ul>
                                ) : null} */}
                            </div>
                            {/* </div> */}
                        </div>
                        <div className="genAIRecommended-main-disable-ai-overview-right">
                            {isShowAIOverview() && <div className="genAIRecommended-main-disable-ai-overview-classSection">
                                {isDisableAIOverviewProcessing ? <img
                                    src={imsLoader}
                                    alt="Loading Data"
                                    style={{ height: "18px" }}
                                /> : <><input
                                    type="checkbox"
                                    id={`isDisableAIOverview`}
                                    value="isDisableAIOverview"
                                    name="classCheckBox"
                                    className="cname"
                                    onChange={handleOnClickIsDisableAIOverview}
                                    checked={isDisableAIOverview}
                                    class="k-checkbox"
                                    style={{ margin: "0px" }}
                                />
                                    <span onClick={handleOnClickIsDisableAIOverview} className="genAIRecommended-main-title">Document Search Only</span></>}

                            </div>}
                            <div style={{ visibility: "hidden", width: "125px" }} >&nbsp;</div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}